import React, { useState } from "react";

import FilterListIcon from "@mui/icons-material/FilterList";
import { Box, ButtonBase, Fade, FormControlLabel, Menu, MenuItem, Radio, RadioGroup, Typography } from "@mui/material";

const FilterButton = ({ filter, onFilterSelect, hideLabel, data }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleFilterSelect = (e) => {
    onFilterSelect(e.target.value);
    handleClose();
  };

  return (
    <Box position="relative">
      <ButtonBase
        sx={{
          px: 2,
          minWidth: !hideLabel ? "100px" : 'auto',
          height: { xs: "37px", md: "46px" },
          bgcolor: "#fff",
          gap: 2,
          justifyContent: "space-between",
          border: "1px solid #DDDDDD",
          borderRadius: "6px",
        }}
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {!hideLabel && <Typography color="#848694" noWrap fontSize={{ xs: "12px", md: "14px" }}>
          {filter || "Filter"}
        </Typography>}
        <FilterListIcon sx={{ width: "17px", height: "17px", color: "#919191" }} />
      </ButtonBase>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
          sx: {
            width: "250px",
            pb: 2,
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem
          sx={{
            mx: 0.5,
            mb: 0.5,
            color: "#7D8FA9",
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          Filters
        </MenuItem>
        <RadioGroup aria-labelledby="demo-controlled-radio-buttons-group" name="controlled-radio-buttons-group" value={filter} onChange={_handleFilterSelect}>
          {data?.map((item) => (
            <MenuItem
              key={item}
              onClick={() => {
                onFilterSelect(item);
                handleClose();
              }}
            >
              <FormControlLabel
                value={item}
                control={<Radio sx={{ color: "black" }} size="small" />}
                label={
                  <Typography fontSize="15px" fontWeight={500} >
                    {item}
                  </Typography>
                }
                sx={{
                  mx: 0.5,
                  width: "100%",
                  height: "18px",
                  color: "#7D8FA9",
                  justifyContent: "space-between",
                }}
                labelPlacement="start"
              />
            </MenuItem>
          ))}
        </RadioGroup>
      </Menu>
    </Box>
  );
};

export default FilterButton;
